export default "__VITE_ASSET__CDVkkdOR__"